import React, { useState, useEffect, useRef } from 'react';
import { connect } from "react-redux";
import { compose } from "redux";
import { LuPlus, LuPanelRight } from "react-icons/lu";
import Collapse from '../assets/images/collapse.svg';
import Expand from '../assets/images/uncollapse.svg';
import { LuArrowLeft } from "react-icons/lu";
import { HiOutlineDotsVertical } from "react-icons/hi";

import { setSidebarCollapsed } from "../store/actions/authActions";

import { createComplianceStandard, resetNewlyCreatedComplianceId, getComplianceStandards, deleteComplianceStandard } from "../store/actions/complianceActions";

import ComplianceOverlay from "../components/Compliance/Overlay";

import Popup from 'reactjs-popup';
import 'reactjs-popup/dist/index.css';

const ComplianceSideBar = (props) => {
  const {
    deleteStandartFN,
    sidebar_collapsed, 
    setSidebarCollapsedFN, 
    complianceStandards, 
    setActiveCompliance, 
    activeComplianceId, 
    newlyCreatedComplianceId, 
    resetNewlyCreatedComplianceIdFN, 
    createComplianceStandardFN, 
    getComplianceStandardsFN, 
    profile 
  } = props;

  const [collapsed, setCollapsed] = useState(true);
  const [isPopupOpen, setIsPopupOpen] = useState(false);
  const [currentCompliance, setCurrentCompliance] = useState(null);

  const closeCreation = () => {
    getComplianceStandardsFN();
    resetNewlyCreatedComplianceIdFN();
    setIsPopupOpen(false);
  };

  const handleDelete = (compliance_id) => {
    deleteStandartFN(compliance_id)
  };

  useEffect(() => {
    setCollapsed(sidebar_collapsed);
  }, [sidebar_collapsed]);

  useEffect(() => {

    if (newlyCreatedComplianceId) {
      ////console.log("newlyCreatedComplianceId", newlyCreatedComplianceId);
      ////console.log(complianceStandards);
      const compliance = complianceStandards?.find(standard => standard.compliance_id === newlyCreatedComplianceId);
      ////console.log("compliance", compliance);
      resetNewlyCreatedComplianceIdFN();
      setCurrentCompliance(compliance);
      setIsPopupOpen(true);
    }
  }, [newlyCreatedComplianceId, complianceStandards, resetNewlyCreatedComplianceIdFN]);


  const [hoveredStandardId, setHoveredStandardId] = useState(null);

  const [menuOpenId, setMenuOpenId] = useState(null);
  const menuRef = useRef(null);


  useEffect(() => {
    function onDocClick(e) {
      if (menuRef.current && !menuRef.current.contains(e.target)) {
        setMenuOpenId(null);
      }
    }
    document.addEventListener("click", onDocClick);
    return () => document.removeEventListener("click", onDocClick);
  }, []);


  return (
    <div className={`static ${collapsed ? 'w-0 min-w-0' : 'w-52 min-w-52'} h-full overflow-y-auto scrollbar-hidden transition-width duration-300 p-0 bg-[#F0F0F2]`}>
      <div className="flex flex-col w-full items-center">
        {collapsed && (
          <div className={`flex justify-end ${!collapsed ? 'absolute' : ''}`}>
            <div className={`${collapsed ? 'relative right-0 top-[100px]' : ''}`}>
              <button onClick={() => setSidebarCollapsedFN(!collapsed)} className={collapsed ? "p-3" : "p-2"}>
                <img src={collapsed ? Expand : Collapse} alt="Toggle" className="w-7 h-7 hover:opacity-70" />
              </button>
            </div>
          </div>
        )}

        {!collapsed && (
          <div className="flex items-center w-full h-16 border-b border-gray-300">
            <p className="text-[#3b3b3b] font-bold text-sm flex-grow ml-4">Compliance Standards</p>
            <div className="flex">
              {profile?.role === "Admin" && (
                <button onClick={() => createComplianceStandardFN()} className="ml-4 p-0">
                  <LuPlus className="w-4 h-4 hover:text-[#3b3b3b]" />
                </button>
              )}
              <button
                onClick={() => setSidebarCollapsedFN(!collapsed)}
                className="p-2 hover:opacity-80 transition"
                title="Toggle sidebar"
              >
                <LuPanelRight className="w-5 h-5 text-[#3b3b3b] hover:text-black" />
              </button>
            </div>
          </div>
        )}

<nav className="flex flex-col mb-2 relative">
  {!collapsed &&
    complianceStandards?.filter(
      (standard) => profile.role !== "User" || standard.compliance_id === profile.compliance_id
    ).map((standard) => (
      <div
        key={standard.compliance_id} // Key is applied to the top-level div
        className={`flex items-center justify-between cursor-pointer w-48 hover:bg-white hover:bg-opacity-100 hover:rounded hover:shadow-lg m-2 ${
          activeComplianceId === standard.compliance_id ? 'bg-white rounded shadow-lg' : ''
        }`
      }
        onMouseEnter={() => setHoveredStandardId(standard.compliance_id)}
        onMouseLeave={() => setHoveredStandardId(null)}
        onClick={() => {
          ////console.log("Setting active compliance ID:", standard.compliance_id);
          setActiveCompliance(standard.compliance_id); // This should be working correctly now
        }}
      >
        <div className="flex items-center">
          <button
            title={standard.name}
            className="flex items-center justify-center w-8 h-8 m-2 rounded-xl hover:bg-white hover:bg-opacity-20 ml-2"
            style={{ backgroundColor: standard.color }}
          >
            <span className="text-white font-bold text-[10px]">
              {standard.name
                .split(' ')
                .filter((word) => word.toLowerCase() !== 'and')
                .map((word) => word.charAt(0).toUpperCase())
                .slice(0, 2)
                .join('')}
            </span>
          </button>
          {!collapsed && (
            <span className="text-[12px]">
              {standard.name.length > 18 ? `${standard.name.substring(0, 18)}...` : standard.name}
            </span>
          )}
        </div>

        {/* Edit Button */}
        {(standard.compliance_id === activeComplianceId || hoveredStandardId === standard.compliance_id) && (
          <div className="relative inline-block" ref={menuRef}>
            <button
              className="ml-2 p-1 text-[#3b3b3b] hover:text-white hover:bg-[#3b3b3b] rounded-full"
              title="Options"
              onClick={(e) => {
                e.stopPropagation();
                setMenuOpenId(menuOpenId === standard.compliance_id ? null : standard.compliance_id);
              }}
            >
              <HiOutlineDotsVertical className="text-gray-500" />
            </button>

            {menuOpenId === standard.compliance_id && (
              <div
                className="absolute right-0 mt-2 w-40 bg-white rounded-md shadow-lg border border-gray-200 z-50"
                onClick={(e) => e.stopPropagation()}
              >
                <button
                  className="w-full text-left px-4 py-2 text-sm hover:bg-gray-100"
                  onClick={() => {
                    
                    setCurrentCompliance(standard);
                    setIsPopupOpen(true);
                    setMenuOpenId(null);
                  }}
                >
                  Edit
                </button>

                <button
                  className="w-full text-left px-4 py-2 text-sm text-red-600 hover:bg-gray-100"
                  onClick={() => {
                    handleDelete(standard.compliance_id)
                    setMenuOpenId(null);
                  }}
                >
                  Delete
                </button>
              </div>
            )}
          </div>
        )}
      </div>
    ))}
</nav>
      </div>

      <Popup
        open={isPopupOpen}
        onClose={closeCreation}
        contentStyle={{ overflow: 'auto', maxHeight: '80vh', width: '810px', marginTop: '14vh' }}
      >
        <ComplianceOverlay close={closeCreation} compliance={currentCompliance} edit={true} />
      </Popup>
    </div>
  );
};

const mapStateToProps = (state) => {
  return {
    profile: state.profile.profile,
    sidebar_collapsed: state.auth.sidebar_collapsed,
    newlyCreatedComplianceId: state.compliance.newlyCreatedComplianceId,
    complianceStandards: state.compliance.complianceStandards,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    setSidebarCollapsedFN: (collapsed) => dispatch(setSidebarCollapsed(collapsed)),
    createComplianceStandardFN: () => dispatch(createComplianceStandard()),
    resetNewlyCreatedComplianceIdFN: () => dispatch(resetNewlyCreatedComplianceId()),
    getComplianceStandardsFN: () => dispatch(getComplianceStandards()),
    deleteStandartFN: (compliance_id) => dispatch(deleteComplianceStandard(compliance_id)),
  };
};

export default compose(connect(mapStateToProps, mapDispatchToProps))(ComplianceSideBar);